<template>
    <div class="page-container">
        <div class="resonance-detail-page">
            <div class="back-row" @click="goBack"><img class="back-img" src="../../images/back.svg" alt=""></div>
            <div class="resonance-end-label-container" v-if="stateCode === 2">
                <div class="resonance-end-label-1">{{ this.localize('共振结束') }}</div>
                <div class="resonance-end-label-2">{{ this.localize('赎回共振金') }}</div>
            </div>
            <div class="resonance-not-start" v-if="stateCode === 0">
                {{ this.localize('共振未开始') }}
            </div>
            <div class="resonance-not-start" v-if="stateCode === -2">
                {{ this.localize('无剩余能量') }}
            </div>
            <div class="in-resonance-label" v-if="stateCode === 4">
                {{ this.localize('超时，NFT即将失效') }}
            </div>
            <div class="in-resonance-label" v-if="stateCode === -1">
                {{ this.localize('NFT已经失效') }}
            </div>
            <div class="in-resonance-label" v-if="stateCode === 1">
                {{ this.localize('共振中，距离共振结束还有') }}
            </div>
            <div class="claim-resonance-reward-label" v-if="stateCode === 3">
                {{ this.localize('领取奖励') + this.resonanceReward + 'U' }}
            </div>
            <div class="resonance-ani-container">
                <ResonanceAni :isAnimating="animating"></ResonanceAni>
            </div>

            <div class="in-resonance-label-2" v-if="stateCode === 1">
                {{ this.countdownDisplay }}
            </div>
            <div class="claim-resonance-reward-countdown-label" v-if="stateCode === 3">
                {{ this.countdownDisplay }}
            </div>

            <div class="resonance-overtime-label" v-if="stateCode === 4">
                {{ this.countdownDisplay }}
            </div>
        </div>
        <div v-if="this.getBtnTxt() !== null" class="resonance-btn" @click="onMainBtnClick">{{ this.getBtnTxt() }}</div>
    </div>
</template>
<script>

import {
    getNftExpireTime,
    getNFTInfo,
    getNftResonancePeriod,
    getNftResonanceRewardExpireTime,
    nftEthCall,
    usdtEthCall,
    startResonance,
    sendErc20Trans, interactorEthCall
} from "@/utils/web3Helper";
import {parseUnits, formatUnits} from 'ethers'
import macau from "@/images/nft/macau.webp";
import dubai from "@/images/nft/dubai.webp";
import monaco from "@/images/nft/monaco.webp";
import lasvegas from "@/images/nft/lasvegas.webp";
import {getFormatedCountdownTime, getNftStateCode, sleep, withdrawResonanceDeposit, getTokenRemainEnergy} from "@/utils/methods";
import {hideLoading, showLoading} from "@/utils/spinnerHelper";
import {Interactor} from "@/utils/constants";
import {showToast} from "@/utils/toastHelper";
import {postRequestAsync} from "@/utils/request";
import {v4} from "uuid";
import ResonanceAni from "@/components/ResonanceAni.vue";
import HeaderComponent from "@/components/HeaderComponent.vue";
import ConfirmModal from "@/components/ConfirmModal.vue";

const moment = require('moment-timezone')

export default {
    name: 'ResonanceDetailPage',
    inject: ['langStore', 'localize'],
    components: {
        ResonanceAni
    },
    async mounted() {
        this.resonancePeriod = Number(await getNftResonancePeriod())
        this.nftExpireTime = Number(await getNftExpireTime())
        this.nftResonanceRewardExpireTime = Number(await getNftResonanceRewardExpireTime())
        await this.initPage()
    },
    data() {
        return {
            currentNftStateCode: 0,
            nft: null,
            imgUrl: {
                '0': macau,
                '1': dubai,
                '2': monaco,
                '3': lasvegas

            },
            resonancePeriod: null,
            nftExpireTime: null,
            interval: null,
            stateLabel: '',
            stateCode: -2,
            nftResonanceRewardExpireTime: 0,
            animating: false,
            countdownDisplay: '',
            resonanceReward: 0
        }
    },
    computed: {
        myWalletAddress() {
            return this.$store.state.connectedWallet
        }
    },
    methods: {
        async initPage() {
            const loadingId = v4()
            showLoading(this.localize('操作中'), loadingId)
            try {
                const tokenId = this.$route.query.tokenId
                console.log(`tokenId: ${tokenId}`)
                const tokenInfo = await getNFTInfo(tokenId)
                this.nft = {
                    name: tokenInfo['2'],
                    tokenId: tokenId,
                    nftType: Number(tokenInfo['0']),
                    image: this.imgUrl[Number(tokenInfo['0'])],
                    energy: Number(tokenInfo['3']) / Math.pow(10, 18),
                    energyUsed: Number(tokenInfo['4']) / Math.pow(10, 18),
                    energyRemain: formatUnits(tokenInfo['3'] - tokenInfo['4'], 18),
                    computingPower: Number(tokenInfo['5']) / Math.pow(10, 18),
                    fuel: Number(tokenInfo['6']) / Math.pow(10, 18),
                    resonanceDeposit: formatUnits(tokenInfo['6'] / 2n * 15n / 10n, 18),
                    startResonanceTime: parseInt(tokenInfo['7']),
                    startResonanceTimeString: moment(parseInt(tokenInfo['7'])).tz('Asia/Shanghai').format('YYYY-MM-DD HH:mm:ss'),
                    createdTimeString: moment(Number(tokenInfo['1']) * 1000).tz('Asia/Shanghai').format('YYYY-MM-DD HH:mm:ss'),
                    resonanceDepositWithdrawTimestamp: parseInt(moment(Number(tokenInfo['8']) * 1000).format('X')),
                    round: tokenInfo['9'],
                }
                const resonanceRewardRate = await nftEthCall('resonanceRewardRate')
                console.log(`resonanceRewardRate: ${resonanceRewardRate}`)
                this.resonanceReward = formatUnits(tokenInfo['6'] * BigInt(resonanceRewardRate) / 2000n, 18)
                console.log(`resonanceReward: ${this.resonanceReward}`)
                this.createInterval()
            } finally {
                hideLoading('all')
            }

        },
        goBack() {
            this.$router.push({
                name: 'resonance'
            })
        },
        getBtnTxt() {
            if (!this.nft) return null
            const stateCode = getNftStateCode(this.nft, this.resonancePeriod, this.nftExpireTime, this.nftResonanceRewardExpireTime)
            switch (stateCode) {
                case 0:
                    return this.localize('进入共振');
                case 2:
                    return this.localize(`赎回`)
                case 3:
                    return this.localize(`领取奖励`)
                case 4:
                    return this.localize(`开始共振`)
            }
            return null
        },
        getNftStateCode() {
            if (!this.nft) return
            const stateCode = getNftStateCode(this.nft, this.resonancePeriod, this.nftExpireTime, this.nftResonanceRewardExpireTime)
            if (stateCode === 1) {
                this.animating = true
            } else {
                this.animating = false
            }
            return stateCode
        },
        createInterval() {
            if (this.interval) {
                clearInterval(this.interval)
            }
            this.interval = setInterval(() => {
                this.stateCode = this.getNftStateCode(this.nft, this.resonancePeriod, this.nftExpireTime, this.nftResonanceRewardExpireTime)
                if (this.stateCode === 3) {
                    const currentTimestamp = parseInt(moment().format('X'))
                    this.countdownDisplay = getFormatedCountdownTime(this.nftResonanceRewardExpireTime - (currentTimestamp - this.nft?.resonanceDepositWithdrawTimestamp))
                }
                if (this.stateCode === 1) {
                    const currentTimestamp = parseInt(moment().format('X'))
                    this.countdownDisplay = getFormatedCountdownTime(this.resonancePeriod - (currentTimestamp - this.nft?.startResonanceTime))
                }
                if (this.stateCode === 4) {
                    const currentTimestamp = parseInt(moment().format('X'))
                    this.countdownDisplay = getFormatedCountdownTime(this.nftExpireTime - (currentTimestamp - this.nft?.resonanceDepositWithdrawTimestamp))
                }
            }, 1000)
        },
        async onMainBtnClick() {
            const stateCode = getNftStateCode(this.nft, this.resonancePeriod, this.nftExpireTime, this.nftResonanceRewardExpireTime)
            console.log(`stateCode: ${stateCode}`)
            if (stateCode === 2) {
                await this.endResonance()
            } else if (stateCode === 0 || stateCode === 3 || stateCode === 4) {
                await this.startResonance()
            }
        },
        async endResonance() {
            await withdrawResonanceDeposit(this.nft, this.myWalletAddress)

            await this.initPage()
        },
        async startResonance() {

            if (!this.nft) return
            const energyRemain = await getTokenRemainEnergy(this.nft.tokenId)
            console.log(energyRemain)
            if(energyRemain < 1) {
                showToast(this.localize('无剩余能量'))
                return
            }
            const loadingId = v4()
            showLoading(this.localize('操作中'), loadingId)
            try {
                const resonanceDeposit = this.nft?.resonanceDeposit
                const allowance = BigInt(await usdtEthCall('allowance', [this.myWalletAddress, Interactor]))

                console.log(`allowance: ${allowance}`)
                console.log(`resonanceDeposit: ${resonanceDeposit}`)
                const resonanceDepositInfo = await interactorEthCall('resonanceDepositMap', [this.myWalletAddress])
                const isResonanceDepositInUse = resonanceDepositInfo[3]
                const resonanceAlreadyDeposit = BigInt(resonanceDepositInfo[0])
                console.log(`isResonanceDepositInUse: ${isResonanceDepositInUse}`)
                console.log(`resonanceAlreadyDeposit: ${resonanceAlreadyDeposit}`)
                console.log(`parseUnits(resonanceDeposit.toString(), 18): ${parseUnits(resonanceDeposit.toString(), 18)}`)
                if (resonanceAlreadyDeposit < parseUnits(resonanceDeposit.toString(), 18) || isResonanceDepositInUse === true) {
                    if (allowance < parseUnits(resonanceDeposit.toString(), 18)) {
                        console.log(`allowance < resonanceDeposit`)
                        const {success} = await sendErc20Trans('approve', [Interactor, parseUnits(resonanceDeposit.toString(), 18)])
                        if (success !== true) {
                            showToast(this.localize('授权失败'))
                            hideLoading()
                            return
                        }
                        showToast(this.localize('授权成功'))
                        await sleep(3000)
                    }
                }

                const sigResult = await postRequestAsync('sig/getResonanceSig',
                    {wallet: this.myWalletAddress, tokenId: this.nft?.tokenId})

                if (sigResult?.code !== 200 || sigResult?.msg?.nonce === null || !sigResult?.msg?.timestamp || !sigResult?.msg?.deadline || !sigResult?.msg?.signature) {
                    showToast(this.localize('获取数据失败'))
                    hideLoading()
                    return
                }
                const {
                    success,
                    txHash
                } = await startResonance(this.nft?.tokenId, sigResult?.msg?.nonce, sigResult?.msg?.timestamp, sigResult?.msg?.deadline, sigResult?.msg?.signature)

                if (success === true) {
                    await sleep(3000)
                    await this.reportStartResonance(txHash)
                    showToast(this.localize('操作成功'))
                    this.animating = true
                    await this.initPage()
                } else {
                    showToast(this.localize('操作失败'))
                }
            } finally {
                hideLoading(loadingId)
            }
        },
        async reportStartResonance(tx) {
            try {
                const sigResult = await postRequestAsync('reward/reportResonanceReward',
                    {wallet: this.myWalletAddress, tokenId: this.nft?.tokenId, tx: tx})
            } catch (e) {

            }

        }
    }
}
</script>
<style scoped>
.resonance-detail-page {
    display: flex;
    flex-direction: column;
    width: 100%;
    align-items: center;
    gap: 1em;
}

.nft-name {
    color: #48FFA1;
    font-size: 2em;
}

.back-row {
    width: 100%;
    text-align: start;
}

.back-img {
    width: 3em;
}

.nft-card-img {
    width: 40%;
}

.nft-state {
    color: #38FF59;
    font-size: 1.8em;
}

.resonance-btn {
    background-color: #38FF59;
    color: #000000;
    font-size: 1.8em;
    padding: 0.4em 0.8em;
    border-radius: 0.2em;
    position: absolute;
    bottom: 3em;
    left: 50%;
    transform: translateX(-50%);
}

.page-container {
    background: #747474;
    background: radial-gradient(circle, rgba(116, 116, 116, 1) 0%, rgba(1, 1, 1, 1) 100%);
}

.resonance-ani-container {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
}

.resonance-end-label-container {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.resonance-end-label-1 {
    font-size: 2.4em;
    background: linear-gradient(to right, #FED9AE, #FE6969);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    color: transparent;
}

.resonance-end-label-2 {
    font-size: 2.4em;
    background: linear-gradient(to right, #D0B5FF, #FE979E);
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    color: transparent;
}

.in-resonance-label, .claim-resonance-reward-label, .resonance-not-start {
    font-size: 2.4em;
    color: #38FF59;
}

.in-resonance-label-2, .claim-resonance-reward-countdown-label, .resonance-overtime-label {

    font-size: 2.4em;
    color: #38FF59;
    position: absolute;
    left: 50%;
    bottom: 20%;
    transform: translateX(-50%);
}
</style>